import { state } from "../../../../interfaces/interfaces";
import { applyChargeRateDiscount, isPromoCodeValid } from "@utils/charges";

export const chargeMiddleware = async (action: { payload: { name: string; value: any } }, next: any) => {
  switch (action.payload.name) {
    case "RatesRateReason":
      applyChargeRateDiscount();
      return next(action);

    case "RatesDiscount":
      return next(action);

    case "PromoCode":
      action.payload.value = action.payload.value.toUpperCase();
      action.payload.value.length > 3 && isPromoCodeValid(action.payload.value.toUpperCase());
      action.payload.value.length <= 3 && (state.PromoCodeValid = false);
      return next(action);

    default:
      return next(action);
  }
};
